import { Product } from 'src/models/product/_types';

import { usePosContext } from '../PosContext';

import { PosProductCard } from './PosProductCard';
import PosProductFinderCard from './PosProductFinderCard';

interface PosProductWrapperProps {
  product: Product;
}

export default function PosProductWrapper({ product }: PosProductWrapperProps) {
  const { getItemConfig, isGuestCheckout } = usePosContext();

  const itemConfig = getItemConfig(product.id);

  const allowedProductsForGuestCheckout = ['product', 'product-variant'];

  if (
    isGuestCheckout &&
    !allowedProductsForGuestCheckout.includes(itemConfig?.itemType || '')
  ) {
    return null;
  }

  if (itemConfig?.type === 'collection') {
    return (
      <PosProductFinderCard
        title={product.name || ''}
        description={product.description || ''}
        itemType={itemConfig?.itemType || ''}
        itemId={itemConfig?.itemId || ''}
      />
    );
  }

  return (
    <PosProductCard itemType={itemConfig?.itemType || ''} itemId={product.id} />
  );
}
